import React from 'react'
import { Provider } from 'react-redux'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import router from '../routers/router'
import adminRouter from '../routers/adminRouter'
import store from '../store'
import routeUtil from '../utils/route.util'
import Alert from './Alert/Alert'
import Confirm from './Confirm/Confirm'
import Panel from './Panel/Panel'
import AdminPanel from './admin/Panel/Panel'
import ProgressBar from './ProgressBar/ProgressBar'
import NotFound from '../views/NotFound'
import ProtectedRoute from './ProtectedRoute'
import HistoryListener from './HistoryListener'
import LiveChat from './LiveChat'

function App () {
  return (
        <Provider store={store}>
            <ProgressBar/>
            <Router>
                <Switch>
                    <Route
                        exact={true}
                        path={router.logout.path}
                        component={router.logout.view}/>
                    <Route
                        exact={true}
                        path={adminRouter.signIn.path}
                        component={adminRouter.signIn.view}/>
                    <Route exact={true} path={routeUtil.publicRoutePaths()}>
                        <LiveChat>
                            <Switch>
                                <Route
                                    exact={true}
                                    path={router.signIn.path}
                                    component={router.signIn.view}/>
                                <Route
                                    exact={true}
                                    path={router.resetPassword.path}
                                    component={router.resetPassword.view}/>
                                <Route
                                    exact={true}
                                    path={router.updatePassword.path}
                                    component={router.updatePassword.view}/>
                                <Route
                                    exact={true}
                                    path={router.trial.path}
                                    component={router.trial.view}/>
                                <Route
                                    exact={true}
                                    path={router.subscribe.path}
                                    component={router.subscribe.view}/>
                                <Route
                                    exact={true}
                                    path={router.paymentConfirmation.path}
                                    component={router.paymentConfirmation.view}/>
                                <Route
                                    exact={true}
                                    path={router.trialCustomLabel.path}
                                    component={router.trialCustomLabel.view}/>
                                <Route
                                    exact={true}
                                    path={router.trialProductionCustomLabel.path}
                                    component={router.trialProductionCustomLabel.view}/>
                                <Route
                                    exact={true}
                                    path={router.terms.path}
                                    component={router.terms.view}/>
                                <Route
                                    exact={true}
                                    path={router.emailVerify.path}
                                    component={router.emailVerify.view}/>
                                <Route
                                    exact={true}
                                    path={router.labelApproval.path}
                                    component={router.labelApproval.view}/>
                            </Switch>
                        </LiveChat>
                    </Route>
                    <Route path={routeUtil.adminRoutePaths()}>
                        <ProtectedRoute allowed="admin">
                            <AdminPanel>
                                <Switch>
                                    <Route
                                        exact={true}
                                        path={adminRouter.subscribers.path}
                                        component={adminRouter.subscribers.view}/>
                                    <Route
                                        exact={true}
                                        path={adminRouter.subscriberCreate.path}
                                        component={adminRouter.subscriberCreate.view}/>
                                    <Route
                                        exact={true}
                                        path={adminRouter.subscriberEdit.path}
                                        component={adminRouter.subscriberEdit.view}/>
                                    <Route
                                        exact={true}
                                        path={adminRouter.users.path}
                                        component={adminRouter.users.view}/>
                                    <Route
                                        exact={true}
                                        path={adminRouter.userCreate.path}
                                        component={adminRouter.userCreate.view}/>
                                    <Route
                                        exact={true}
                                        path={adminRouter.userEdit.path}
                                        component={adminRouter.userEdit.view}/>
                                    <Route
                                        exact={true}
                                        path={adminRouter.siteCreate.path}
                                        component={adminRouter.siteCreate.view}/>
                                    <Route
                                        exact={true}
                                        path={adminRouter.sites.path}
                                        component={adminRouter.sites.view}/>
                                    <Route
                                        exact={true}
                                        path={adminRouter.siteEdit.path}
                                        component={adminRouter.siteEdit.view}/>
                                    <Route
                                        exact={true}
                                        path={adminRouter.trials.path}
                                        component={adminRouter.trials.view}/>
                                    <Route
                                        exact={true}
                                        path={adminRouter.metas.path}
                                        component={adminRouter.metas.view}/>
                                    <Route
                                        exact={true}
                                        path={adminRouter.metaCreate.path}
                                        component={adminRouter.metaCreate.view}/>
                                    <Route
                                        exact={true}
                                        path={adminRouter.metaEdit.path}
                                        component={adminRouter.metaEdit.view}/>
                                </Switch>
                            </AdminPanel>
                        </ProtectedRoute>
                    </Route>
                    <Route path={routeUtil.routePaths()}>
                        <ProtectedRoute allowed="user">
                            <LiveChat>
                                <Panel>
                                    <Switch>
                                        <Route
                                            exact={true}
                                            path={router.dashboard.path}
                                            component={router.dashboard.view}/>
                                        <Route
                                            exact={true}
                                            path={router.palletDetails.path}
                                            component={router.palletDetails.view}/>
                                        <Route
                                            exact={true}
                                            path={router.standaloneCases.path}
                                            component={router.standaloneCases.view}/>
                                        <Route
                                            exact={true}
                                            path={router.standaloneCaseCreate.path}
                                            component={router.standaloneCaseCreate.view}/>
                                        <Route
                                            exact={true}
                                            path={router.purchaseOrders.path}
                                            component={router.purchaseOrders.view}/>
                                        <Route
                                            exact={true}
                                            path={router.purchaseOrderEnter.path}
                                            component={router.purchaseOrderEnter.view}/>
                                        <Route
                                            exact={true}
                                            path={router.purchaseOrdersImport.path}
                                            component={router.purchaseOrdersImport.view}/>
                                        <Route
                                            exact={true}
                                            path={router.inventoryCreate.path}
                                            component={router.inventoryCreate.view}/>
                                        <Route
                                            exact={true}
                                            path={router.barePallets.path}
                                            component={router.barePallets.view}/>
                                        <Route
                                            exact={true}
                                            path={router.barePalletCreate.path}
                                            component={router.barePalletCreate.view}/>
                                        <Route
                                            exact={true}
                                            path={router.inventories.path}
                                            component={router.inventories.view}/>
                                        <Route
                                            exact={true}
                                            path={router.inventoryHistory.path}
                                            component={router.inventoryHistory.view}/>
                                        <Route
                                            exact={true}
                                            path={router.inventory.path}
                                            component={router.inventory.view}/>
                                        <Route
                                            exact={true}
                                            path={router.transfer.path}
                                            component={router.transfer.view}/>
                                        <Route
                                            exact={true}
                                            path={router.stockOnHand.path}
                                            component={router.stockOnHand.view}/>
                                        <Route
                                            exact={true}
                                            path={router.bulkTransfer.path}
                                            component={router.bulkTransfer.view}/>
                                        <Route
                                            exact={true}
                                            path={router.licensePlates.path}
                                            component={router.licensePlates.view}/>
                                        <Route
                                            exact={true}
                                            path={router.licensePlateUpload.path}
                                            component={router.licensePlateUpload.view}/>
                                        <Route
                                            exact={true}
                                            path={router.userSubscription.path}
                                            component={router.userSubscription.view}/>
                                        <Route
                                            exact={true}
                                            path={router.systemLabels.path}
                                            component={router.systemLabels.view}/>
                                        <Route
                                            exact={true}
                                            path={router.systemLabelCreate.path}
                                            component={router.systemLabelCreate.view}/>
                                        <Route
                                            exact={true}
                                            path={router.systemLabelView.path}
                                            component={router.systemLabelView.view}/>
                                        <Route
                                            exact={true}
                                            path={router.systemLabelPrint.path}
                                            component={router.systemLabelPrint.view}/>
                                        <Route
                                            exact={true}
                                            path={router.systemLabelEdit.path}
                                            component={router.systemLabelEdit.view}/>
                                        <Route
                                            exact={true}
                                            path={router.systemLabelPrintsPaginate.path}
                                            component={router.systemLabelPrintsPaginate.view}/>
                                        <Route
                                            exact={true}
                                            path={router.labelBuilder.path}
                                            component={router.labelBuilder.view}/>
                                        <Route
                                            exact={true}
                                            path={router.categories.path}
                                            component={router.categories.view}/>
                                        <Route
                                            exact={true}
                                            path={router.apiCredentials.path}
                                            component={router.apiCredentials.view}/>
                                        <Route
                                            exact={true}
                                            path={router.categoryCreate.path}
                                            component={router.categoryCreate.view}/>
                                        <Route
                                            exact={true}
                                            path={router.categoryEdit.path}
                                            component={router.categoryEdit.view}/>
                                        <Route
                                            exact={true}
                                            path={router.locationCreate.path}
                                            component={router.locationCreate.view}/>
                                        <Route
                                            exact={true}
                                            path={router.locationEdit.path}
                                            component={router.locationEdit.view}/>
                                        <Route
                                            exact={true}
                                            path={router.userCreate.path}
                                            component={router.userCreate.view}/>
                                        <Route
                                            exact={true}
                                            path={router.userEdit.path}
                                            component={router.userEdit.view}/>
                                        <Route
                                            exact={true}
                                            path={router.items.path}
                                            component={router.items.view}/>
                                        <Route
                                            exact={true}
                                            path={router.itemCreate.path}
                                            component={router.itemCreate.view}/>
                                        <Route
                                            exact={true}
                                            path={router.itemEdit.path}
                                            component={router.itemEdit.view}/>
                                        <Route
                                            exact={true}
                                            path={router.inventoryReport.path}
                                            component={router.inventoryReport.view}/>
                                        <Route
                                            exact={true}
                                            path={router.shippingReport.path}
                                            component={router.shippingReport.view}/>
                                        <Route
                                            exact={true}
                                            path={router.packTraceReport.path}
                                            component={router.packTraceReport.view}/>
                                        <Route
                                            exact={true}
                                            path={router.labelTraceReport.path}
                                            component={router.labelTraceReport.view}/>
                                        <Route
                                            exact={true}
                                            path={router.labelTrace.path}
                                            component={router.labelTrace.view}/>
                                        <Route
                                            exact={true}
                                            path={router.insAndOutsReport.path}
                                            component={router.insAndOutsReport.view}/>
                                        <Route
                                            exact={true}
                                            path={router.purchaseOrder.path}
                                            component={router.purchaseOrder.view}/>
                                        <Route
                                            exact={true}
                                            path={router.purchaseOrderEdit.path}
                                            component={router.purchaseOrderEdit.view}/>
                                        <Route
                                            exact={true}
                                            path={router.workOrderCreate.path}
                                            component={router.workOrderCreate.view}/>
                                        <Route
                                            exact={true}
                                            path={router.workOrder.path}
                                            component={router.workOrder.view}/>
                                        <Route
                                            exact={true}
                                            path={router.packTraceCreate.path}
                                            component={router.packTraceCreate.view}/>
                                        <Route
                                            exact={true}
                                            path={router.packTraces.path}
                                            component={router.packTraces.view}/>
                                        <Route
                                            exact={true}
                                            path={router.packTrace.path}
                                            component={router.packTrace.view}/>
                                        <Route
                                            exact={true}
                                            path={router.shipOrderPallets.path}
                                            component={router.shipOrderPallets.view}/>
                                        <Route
                                            exact={true}
                                            path={router.users.path}
                                            component={router.users.view}/>
                                        <Route
                                            exact={true}
                                            path={router.locations.path}
                                            component={router.locations.view}/>
                                        <Route
                                            exact={true}
                                            path={router.locationSearch.path}
                                            component={router.locationSearch.view}/>
                                        <Route
                                            exact={true}
                                            path={router.receivings.path}
                                            component={router.receivings.view}/>
                                        <Route
                                            exact={true}
                                            path={router.receivingCreate.path}
                                            component={router.receivingCreate.view}/>
                                        <Route
                                            exact={true}
                                            path={router.workOrders.path}
                                            component={router.workOrders.view}/>
                                        <Route
                                            exact={true}
                                            path={router.workOrderCalendar.path}
                                            component={router.workOrderCalendar.view}/>
                                        <Route
                                            exact={true}
                                            path={router.workOrderEdit.path}
                                            component={router.workOrderEdit.view}/>
                                        <Route
                                            exact={true}
                                            path={router.billsOfLading.path}
                                            component={router.billsOfLading.view}/>
                                        <Route
                                            exact={true}
                                            path={router.billOfLadingGenerate.path}
                                            component={router.billOfLadingGenerate.view}/>
                                        <Route
                                            exact={true}
                                            path={router.ship.path}
                                            component={router.ship.view}/>
                                        <Route
                                            exact={true}
                                            path={router.shipOrders.path}
                                            component={router.shipOrders.view}/>
                                        <Route
                                            exact={true}
                                            path={router.shipOrderCreate.path}
                                            component={router.shipOrderCreate.view}/>
                                        <Route
                                            exact={true}
                                            path={router.shipOrder.path}
                                            component={router.shipOrder.view}/>
                                        <Route
                                            exact={true}
                                            path={router.shipOrderEdit.path}
                                            component={router.shipOrderEdit.view}/>
                                        <Route
                                            exact={true}
                                            path={router.caseTransfer.path}
                                            component={router.caseTransfer.view}/>
                                        <Route
                                            exact={true}
                                            path={router.quantityTransfer.path}
                                            component={router.quantityTransfer.view}/>
                                        <Route
                                            exact={true}
                                            path={router.caseAssignment.path}
                                            component={router.caseAssignment.view}/>
                                        <Route
                                            exact={true}
                                            path={router.contacts.path}
                                            component={router.contacts.view}/>
                                        <Route
                                            exact={true}
                                            path={router.contactCreate.path}
                                            component={router.contactCreate.view}/>
                                        <Route
                                            exact={true}
                                            path={router.contactEdit.path}
                                            component={router.contactEdit.view}/>
                                    </Switch>
                                </Panel>
                            </LiveChat>
                        </ProtectedRoute>
                    </Route>
                    <Route
                        path="*"
                        component={NotFound}/>
                </Switch>
                <HistoryListener/>
            </Router>
            <Alert/>
            <Confirm/>
        </Provider>
  )
}

export default App
